import React from 'react';
import {ScrollView} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';
import Text from '/component/base/Text';

import Checkbox from './Checkbox';
import OneLineLayout from './OneLineLayout';
import ProgressBar from './ProgressBar';
import Readonly from './Readonly';

storiesOf('base', module).add('PercentageProgressListItem', () => (
  <ScrollView>
    <FlexView>
      <Spacing size={20}>
        <Heading level={1}>Percentage Progress List Item</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>{'PercentageProgressListItem'}</Code> component accepts{' '}
          <Code>{'label'}</Code>, <Code>{'percentage'}</Code>,{' '}
          <Code>{'numerator'}</Code>, <Code>{'denominator'}</Code>,{' '}
          <Code>{'readonly'}</Code>, <Code>{'hasCheckbox'}</Code> and{' '}
          <Code>{'isChecked'}</Code> props.
        </Text>
        <Spacer size={10} />
        <Text>
          The parent component determines the horizontal padding to allow for
          added flexibility.
        </Text>
      </Spacing>
      <ProgressBar />
      <Checkbox />
      <Readonly />
      <OneLineLayout />
    </FlexView>
  </ScrollView>
));
